module.exports = __webpack_public_path__ + "img/ellipse.e77d552a.svg";